/**
 * Routes where an expanded Voice overlay would dual-paint over the page.
 * Keep the WS session alive — callers collapse chrome only.
 */
export const shouldMinimizeVoiceForPath = (pathname: string | undefined): boolean =>
  !!pathname?.startsWith('/settings');
